// Row lift-on-hover motion, matched to the organizations table (organizations.css).
// Asymmetric easing — snappy easeOutExpo on enter, Material standard on leave —
// with a real shadow cast from above and prefers-reduced-motion honored.
export const rowHoverLiftSx = {
  position: "relative",
  willChange: "transform",
  transition:
    "transform 240ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 240ms cubic-bezier(0.4, 0, 0.2, 1), background-color 120ms ease-out",
  "&:hover": {
    transform: "translateY(-1px)",
    backgroundColor: "#fafafb",
    boxShadow:
      "0 6px 18px -6px rgba(50, 60, 80, 0.12), 0 2px 4px -1px rgba(50, 60, 80, 0.05)",
    zIndex: 1,
    transition:
      "transform 180ms cubic-bezier(0.16, 1, 0.3, 1), box-shadow 180ms cubic-bezier(0.16, 1, 0.3, 1), background-color 120ms ease-out",
  },
  "@media (prefers-reduced-motion: reduce)": {
    transition: "background-color 80ms ease-out !important",
    "&:hover": { transform: "none !important", boxShadow: "none !important" },
  },
} as const;

// A row can only cast a box-shadow / translate when the table isn't border-collapsed.
export const liftableTableSx = {
  borderCollapse: "separate",
  borderSpacing: 0,
} as const;
